function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "cube"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.406 6.086-9-4c-.259-.115-.554-.115-.813 0l-9 4c-.36.161-.593.519-.593.914v10c0 .395.233.753.594.914l9 4c.129.057.268.086.406.086s.277-.029.406-.086l9-4c.361-.161.594-.519.594-.914v-10c0-.395-.233-.753-.594-.914zm-9.406-1.992 6.538 2.906-6.538 2.906-6.538-2.906zm-8 4.445 7 3.111v7.812l-7-3.112zm9 10.922v-7.812l7-3.111v7.812z"
}));

var Svg037Cube = function Svg037Cube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg037Cube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/037-cube.b82bfe67.svg";
export { ForwardRef as ReactComponent };